export const parseErrorMsg = (err: any) => {
  return err.toString().includes('403') ? `Access Denied - ${err}` : err;
};
